// react
import React, { useEffect, useState } from 'react'
import ReactJson from 'react-json-view'
import classNames from 'classnames'

// components
import { Input, Switch, Button, Icon, BUTTON_SIZE, BUTTON_THEME } from '@st-operations/uikit/src/v2'
import toast from '@st-operations/uikit/lib/toast'
import EntityEditForm from '_components/entity-edit-form/index.jsx'
import Select from '_components/select'
import CustomFieldsModal from './CustomFieldsModal'

// hooks
import { useRetractSidebar } from '_hooks'

// services
import { getMappingIds, getSalesforceIntegrationPartners } from '_services/destinations'

import './styles.scss'

// format data in-out to connect API to components
const f = {
  options: (data) => data.map((item) => ({ value: item, label: item?.name })),
  enumOptions: (array) => array.map((name) => ({ value: name, label: name })),
  onChange: (callback) => (item, action) => callback(item?.value ?? null, action.name),
  // the api drops a null reference on save, so clearing one sends an empty value
  refOnChange: (callback) => (item, action) => callback(item?.value ?? '', action.name),
  refValue: (ref) => (ref?._id ? { value: ref, label: ref.name } : null),
  multiOnChange: (callback) => (item, action) =>
    callback(
      item.map(({ value }) => value),
      action.name
    ),
}

const DestinationPage = (props) => {
  useRetractSidebar()
  const [enumMappingId, setEnumMappingId] = useState([])
  const [salesforcePartners, setSalesforcePartners] = useState([])
  const [apiInputFieldsModalOpen, setApiInputFieldsModalOpen] = useState(false)
  const [datasphereInputFieldsModalOpen, setDatasphereInputFieldsModalOpen] = useState(false)

  useEffect(() => {
    getMappingIds().then((data) => setEnumMappingId(data.items))
    getSalesforceIntegrationPartners().then((data) => setSalesforcePartners(data.items))
  }, [])

  const handleError = (error) => {
    if (error?.message?.destination_change_requests?._id) {
      toast('Not authorized. Change request made successfully, contact admin to approve')
      window._history.push(
        `/destination-change-requests/${error.message.destination_change_requests._id}`
      )
    } else if (error?.message) {
      toast.error(error.message)
    }
  }

  return (
    <div id="destination-page">
      <EntityEditForm
        entities="destinations"
        id={props.match.params.id}
        resource="Destinations"
        handleError={handleError}
      >
        {(args) => {
          const { item, schema, onChange } = args
          return (
            <div className="destination">
              <div className="destination__section-title">
                <h2>General</h2>
                <hr />
              </div>
              <div className="destination__block">
                <div className="destination__group">
                  <Input
                    name="name"
                    label="Name"
                    type="text"
                    value={item.name}
                    disabled={true}
                    onChange={onChange}
                  />
                  <Input
                    name="slug"
                    label="Slug"
                    type="text"
                    value={item.slug}
                    disabled={true}
                    onChange={onChange}
                  />
                </div>
                <div className="destination__group">
                  <Select
                    name="mapping_id"
                    label="Mapping ID"
                    description={schema.mapping_id.description}
                    onChange={f.onChange(onChange)}
                    options={f.options(enumMappingId)}
                    value={f.options([item.mapping_id])[0]}
                    isClearable={true}
                    isSearchable={true}
                    useReactSelect
                  />
                  <Select
                    name="salesforce_integration_partner"
                    label="Salesforce Integration Partner"
                    description={schema.salesforce_integration_partner?.description}
                    onChange={f.refOnChange(onChange)}
                    options={f.options(salesforcePartners)}
                    value={f.refValue(item.salesforce_integration_partner)}
                    isClearable={true}
                    isSearchable={true}
                    useReactSelect
                  />
                  <Select
                    name="api_integration"
                    label="Api Integration"
                    description={schema.api_integration.description}
                    onChange={f.onChange(onChange)}
                    options={f.enumOptions(schema.api_integration.enum)}
                    value={f.enumOptions([item.api_integration])[0]}
                    isClearable={true}
                    isSearchable={true}
                    useReactSelect
                  />
                  <div className="destination__switch">
                    <p>Use Name As External ID</p>
                    <Switch
                      checked={item.use_name_as_external_id}
                      name="use_name_as_external_id"
                      onChange={(e) => onChange(e.target.checked, 'use_name_as_external_id')}
                    />
                  </div>
                </div>
                <div>
                  <div style={{ display: 'flex', marginLeft: '-20px' }}>
                    <div>
                      <Button
                        size={BUTTON_SIZE.SMALL}
                        theme={BUTTON_THEME.GHOST}
                        onClick={() => {
                          setApiInputFieldsModalOpen(!apiInputFieldsModalOpen)
                        }}
                      >
                        <Icon
                          width="18px"
                          height="24px"
                          icon="externallink"
                          type="outline"
                          color="currentColor"
                        />
                        Apa input fields
                      </Button>
                      <CustomFieldsModal
                        onClose={() => {
                          setApiInputFieldsModalOpen(false)
                        }}
                        item={item}
                        isOpen={apiInputFieldsModalOpen}
                        header="APA input fields"
                        type="apa_input_fields"
                        onChange={onChange}
                      />
                    </div>
                    <div>
                      <Button
                        size={BUTTON_SIZE.SMALL}
                        theme={BUTTON_THEME.GHOST}
                        onClick={() => {
                          setDatasphereInputFieldsModalOpen(!datasphereInputFieldsModalOpen)
                        }}
                      >
                        <Icon
                          width="18px"
                          height="24px"
                          icon="externallink"
                          type="outline"
                          color="currentColor"
                        />
                        Datasphere input fields
                      </Button>

                      <CustomFieldsModal
                        onClose={() => {
                          setDatasphereInputFieldsModalOpen(false)
                        }}
                        item={item}
                        isOpen={datasphereInputFieldsModalOpen}
                        header="Datasphere input fields"
                        type="datasphere_input_fields"
                        onChange={onChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="destination__section-title">
                <h2>Advanced Settings</h2>
                <hr />
              </div>
              <div className="destination__block">
                <div className="destination__group">
                  <div className="destination__switch">
                    <p>Sync With Datapipe</p>
                    {/* <span>{schema.sync_with_datapipe.description}</span> */}
                    <Switch
                      checked={item.sync_with_datapipe}
                      name="sync_with_datapipe"
                      onChange={(e) => onChange(e.target.checked, 'sync_with_datapipe')}
                    />
                  </div>
                  <If condition={item.sync_with_datapipe}>
                    <div className="destination__switch">
                      <p>Monthly Delivery</p>
                      {/* <span>{schema.monthly_delivery.description}</span> */}
                      <Switch
                        checked={item.monthly_delivery}
                        name="monthly_delivery"
                        onChange={(e) => onChange(e.target.checked, 'monthly_delivery')}
                      />
                    </div>
                    <div className="destination__switch">
                      <p>Is Prod</p>
                      <span>{schema.is_prod.description}</span>
                      <Switch
                        checked={item.is_prod}
                        name="is_prod"
                        onChange={(e) => onChange(e.target.checked, 'is_prod')}
                      />
                    </div>
                    <Input
                      name="consent"
                      label="Consent"
                      type="text"
                      value={item.consent}
                      description={schema.consent.description}
                      onChange={onChange}
                    />
                    <Select
                      name="event_sources"
                      label="Event Sources"
                      description={schema.event_sources.description}
                      onChange={f.multiOnChange(onChange)}
                      options={f.enumOptions(schema.event_sources.enum)}
                      value={f.enumOptions(item.event_sources)}
                      isClearable={true}
                      isSearchable={true}
                      isMulti={true}
                      useReactSelect
                    />
                    <Select
                      name="explode_transformer"
                      label="Explode Transformer"
                      description={schema.explode_transformer.description}
                      onChange={f.onChange(onChange)}
                      options={f.enumOptions(schema.explode_transformer.enum)}
                      value={f.enumOptions([item.explode_transformer])[0]}
                      isClearable={true}
                      isSearchable={true}
                      useReactSelect
                    />
                    <Input
                      name="segments_per_user_cap_transformer"
                      label="Segments Per User Cap Transformer"
                      type="text"
                      value={item.segments_per_user_cap_transformer}
                      onChange={onChange}
                      description={schema.segments_per_user_cap_transformer.description}
                    />
                  </If>
                </div>
                <If condition={item.sync_with_datapipe}>
                  <div className="destination__group">
                    <div>
                      <div className="destination__cols-decorator">
                        <p>Join Cols Decorator Transformer</p>
                        <span
                          className="st-react-select__caption"
                          style={{ marginLeft: 0, textAlign: 'left' }}
                        >
                          {schema.join_cols_decorator_transformer.description}
                        </span>
                      </div>
                      <div className="destination__cols-decorator-items">
                        {schema.join_cols_decorator_transformer.enum
                          .map((item) => item.replace(/\\/g, ''))
                          .map((decorator) => {
                            const isSelected = decorator === item.join_cols_decorator_transformer
                            return (
                              <div
                                key={decorator}
                                className={classNames('destination__json-select', {
                                  'destination__json-select--selected': isSelected,
                                })}
                              >
                                <ReactJson
                                  src={JSON.parse(decorator)}
                                  name={false}
                                  quotesOnKeys={false}
                                  displayDataTypes={false}
                                  displayObjectSize={false}
                                  enableClipboard={false}
                                />
                                <button
                                  className={classNames('destination__json-radio', {
                                    'destination__json-radio--selected': isSelected,
                                  })}
                                  title={isSelected ? 'remove' : 'select'}
                                  onClick={() => {
                                    if (isSelected) {
                                      onChange(null, 'join_cols_decorator_transformer')
                                    } else {
                                      onChange(decorator, 'join_cols_decorator_transformer')
                                    }
                                  }}
                                >
                                  <span className="destination__json-radio-check" />
                                </button>
                              </div>
                            )
                          })}
                      </div>
                    </div>
                  </div>
                </If>
              </div>
            </div>
          )
        }}
      </EntityEditForm>
    </div>
  )
}

export default DestinationPage
